import { render } from "./ChangeSubscriptionPage.vue?vue&type=template&id=74c59d99"
import script from "./ChangeSubscriptionPage.vue?vue&type=script&lang=js"
export * from "./ChangeSubscriptionPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/mon3m/mon3m/dafater/ManageSPA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__